/**
 * Same-origin linkek ugyanabban a lapban (_self), külső origin új fülben (_blank).
 *
 * @param {string|null|undefined} href
 * @param {string} pageOrigin — window.location.origin a host oldalon
 * @returns {{ target: '_self' | '_blank', rel: string | null }}
 */
export function resolveLinkTarget(href, pageOrigin) {
    const fallback = { target: '_blank', rel: 'noopener noreferrer' };

    if (! href || typeof href !== 'string') {
        return fallback;
    }

    try {
        const url = new URL(href, pageOrigin);

        if (url.origin === pageOrigin) {
            return { target: '_self', rel: null };
        }

        return fallback;
    } catch {
        return fallback;
    }
}
